(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info/assets/match-info.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info/assets/match-info.js');
"use strict";


const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useEffect
} = React;
const {
  fetchMatchInfo
} = svs.components.sportinfo.matchInfoRedux.actions;
const {
  useBetEvent
} = svs.components.sportinfo.matchInfoHooks;
const {
  GeneralMatchInfo,
  Favorites,
  MatchAnalysis,
  StatisticSection,
  StatisticSectionList,
  OverUnder
} = svs.components.sportinfo.matchInfoComponents;
const {
  ProductOdds
} = svs.components.sportinfo.matchInfo;
const {
  useFetchAnalysesByDraw
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const {
  selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber
} = svs.components.sportinfo.gameAnalysesRedux.selectors;
const {
  productIds
} = svs.utils.products;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  SportTypes
} = svs.components.sport.sportTypes;
const getAnalysisSectionHeader = sportType => {
  switch (sportType) {
    case SportTypes.Trotting:
      return 'Loppanalys';
    default:
      return 'Spelanalys';
  }
};
const MatchInfo = _ref => {
  let {
    eventNumber,
    matchId,
    productId,
    branding,
    className,
    theme,
    sportType,
    drawNumber,
    eventTypeId = 1,
    viewProps = {
      renderGeneralMatchInfo: true
    }
  } = _ref;
  const dispatch = useDispatch();
  if (productId === productIds.BOMBEN || productId === productIds.MATCHEN) {
    eventTypeId = EventTypeId.EVENT_1X2;
  }
  const {
    betEvent
  } = useBetEvent({
    productId,
    drawNumber,
    eventNumber
  });
  const classNames = ['statistics-match-info'].concat(className !== null && className !== void 0 ? className : []);
  useEffect(() => {
    if (matchId) {
      dispatch(fetchMatchInfo({
        matchId,
        productId,
        eventNumber,
        drawNumber
      }));
    }
  }, [matchId, dispatch, productId, eventNumber, drawNumber]);
  useFetchAnalysesByDraw(drawNumber, productId);
  const matchAnalysesIds = useSelector(state => selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber(state, productId, drawNumber, matchId, eventNumber));
  const renderAnalyzes = () => React.createElement(StatisticSection, {
    heading: getAnalysisSectionHeader(sportType)
  }, matchAnalysesIds.map(analysisId => React.createElement(MatchAnalysis, {
    analysisId: analysisId,
    branding: branding,
    eventTypeId: eventTypeId,
    key: analysisId,
    theme: theme
  })));

  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(StatisticSectionList, null, matchId && React.createElement(React.Fragment, null, React.createElement(StatisticSection, {
    heading: "Spelstatistik inf\xF6r match"
  }, React.createElement(ProductOdds, {
    betEvent: betEvent,
    eventTypeId: eventTypeId,
    matchId: matchId
  })), sportType === SportTypes.Soccer && React.createElement(StatisticSection, null, React.createElement(OverUnder, {
    betEvent: betEvent,
    matchId: matchId
  }))), matchAnalysesIds.length > 0 && renderAnalyzes(), matchId && React.createElement(Favorites, {
    betEvent: betEvent,
    matchId: matchId
  }), matchId && viewProps.renderGeneralMatchInfo && React.createElement(GeneralMatchInfo, {
    matchId: matchId
  })));
};
setGlobal('svs.components.sportinfo.matchInfo.MatchInfo', MatchInfo);

 })(window);